module.exports = __webpack_public_path__ + "media/components/country-flag/static/fi-5cb87eb502e841e1c264f0731d5c84ba.svg";